var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.42 5.00986C11.8023 4.33021 12.7809 4.33021 13.1632 5.00986L20.4533 17.9701C20.8283 18.6367 20.3466 19.4604 19.5818 19.4604H5.00145C4.23663 19.4604 3.75492 18.6367 4.12988 17.9701L11.42 5.00986ZM12.2916 9.53354C12.6506 9.53354 12.9416 9.82455 12.9416 10.1835V12.7129C12.9416 13.0719 12.6506 13.3629 12.2916 13.3629C11.9326 13.3629 11.6416 13.0719 11.6416 12.7129V10.1835C11.6416 9.82455 11.9326 9.53354 12.2916 9.53354ZM13.0416 15.9604C13.0416 15.5462 12.7058 15.2104 12.2916 15.2104C11.8774 15.2104 11.5416 15.5462 11.5416 15.9604V16.029C11.5416 16.4432 11.8774 16.779 12.2916 16.779C12.7058 16.779 13.0416 16.4432 13.0416 16.029V15.9604Z",
    fill: "#FC545C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.c91e204de90d889f172b877983a7c07c.svg";
export { ForwardRef as ReactComponent };